import Logger from '../lib/logger';
import event from '../lib/mixins/event';
import type DiscountCodeDetector from '../lib/DiscountCodeDetector';

class CheckoutButton {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	NAME: string;
	dom: Element;
	discountCodeDetector: DiscountCodeDetector;
	clickHandler?: (e: Event) => void;

	/**
	 * Class constructor
	 */
	constructor(dom: Element, discountCodeDetector: DiscountCodeDetector) {

		this.NAME = 'CheckoutButton';

		this.dom = dom;
		this.discountCodeDetector = discountCodeDetector;
	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);

		// Store the handler so we can remove it later
		this.clickHandler = (e: Event) => {
			e.preventDefault();
			Logger.info(`${this.NAME} > click`);
			const checkoutUrl = this.discountCodeDetector.getCheckoutURL();
			if (checkoutUrl) {
				window.location.href = checkoutUrl;
				Logger.info(`${this.NAME} > redirecting to ${checkoutUrl}`);
			} else {
				window.location.href = '/checkout';
				Logger.info(`${this.NAME} > redirecting to /checkout`);
			}
		};

		this.dom.addEventListener('click', this.clickHandler);
	}

	/**
	 * destroy - Clean up event listeners
	 */
	destroy() {
		Logger.info(`${this.NAME} > destroy`);
		if (this.dom && this.clickHandler) {
			this.dom.removeEventListener('click', this.clickHandler);
		}
	}

}

Object.assign(CheckoutButton.prototype, event);

export default CheckoutButton;
